import type SinatraState from '../types/SinatraState';

type UserState = SinatraState['user'];
type UserProfile = UserState['profile'];

function describeCount(organizations: unknown): string {
  if (organizations === undefined) return 'missing';
  if (organizations === null) return 'null';
  if (!Array.isArray(organizations)) return typeof organizations;
  return `${organizations.length}`;
}

function isEmptyObject(value: unknown): boolean {
  return (
    typeof value === 'object' &&
    value !== null &&
    Object.keys(value).length === 0
  );
}

/**
 * Describe a profile's organizations, so a stored profile and a /user response
 * can be compared in an error message.
 *
 * For diagnostics and logging only. Emits key names, types and counts — never
 * values, since the output reaches Sentry via console.error.
 */
export function describeProfileOrganizations(
  profile: UserProfile | undefined,
): string {
  if (!profile) return 'profile=missing';
  return [
    `organizations=${describeCount(profile.organizations)}`,
    `profileKeys=[${Object.keys(profile).sort().join(',')}]`,
  ].join(' ');
}

/**
 * Describe the stored user slice when its organizations could not be read.
 * For diagnostics and logging only.
 */
export function describeUserOrganizationsState(user: UserState): string {
  if (!user) return 'user=missing';
  return [
    `isLoggedIn=${!!user.isLoggedIn}`,
    describeProfileOrganizations(user.profile),
    `currentOrg=${isEmptyObject(user.currentOrg) ? 'empty' : 'set'}`,
    `currentRole=${isEmptyObject(user.currentRole) ? 'empty' : 'set'}`,
  ].join(' ');
}

export default describeUserOrganizationsState;
